import { rankingData } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="px-6 md:px-8 max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-3">
          综艺热榜
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          本周最受欢迎的综艺节目排行
        </p>
        <div className="bg-background-100 rounded-2xl overflow-hidden">
          {rankingData.map((item, index) => (
            <a
              key={item.rank}
              href="#carousel"
              className={`flex items-center gap-4 px-6 py-4 hover:bg-background-200/50 transition-colors cursor-pointer ${
                index < rankingData.length - 1 ? 'border-b border-background-200/70' : ''
              }`}
            >
              <div className={`w-8 h-8 rounded-lg flex items-center justify-center font-heading text-sm flex-shrink-0 ${
                item.rank === 1
                  ? 'bg-primary-500 text-white'
                  : item.rank === 2
                  ? 'bg-accent-500 text-white'
                  : item.rank === 3
                  ? 'bg-secondary-500 text-white'
                  : 'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className="text-sm font-semibold text-foreground-800 truncate">{item.title}</span>
                  <span className="text-xs px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 whitespace-nowrap">{item.tag}</span>
                </div>
                <div className="flex items-center gap-2 mt-0.5">
                  <span className="text-xs text-foreground-500">{item.heat}</span>
                  {item.trend === 'up' && <i className="ri-arrow-up-line text-xs text-primary-500"></i>}
                  {item.trend === 'down' && <i className="ri-arrow-down-line text-xs text-foreground-400"></i>}
                  {item.trend === 'stable' && <i className="ri-subtract-line text-xs text-foreground-400"></i>}
                </div>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-400 flex-shrink-0"></i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}